import { render, staticRenderFns } from "./kbVideo.vue?vue&type=template&id=c4809c70&scoped=true"
import script from "./kbVideo.vue?vue&type=script&lang=js"
export * from "./kbVideo.vue?vue&type=script&lang=js"
import style0 from "./kbVideo.vue?vue&type=style&index=0&id=c4809c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4809c70",
  null
  
)

export default component.exports